import { API } from "@/lib/api";

// POST a question and read the server-sent events (start · step_start · step · delta · notice · done · error).
export async function streamAsk(chatId, content, onEvent, signal) {
    const res = await fetch(`${API}/admin/mongo-mcp/chats/${chatId}/messages`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("tf_token") || ""}` },
        body: JSON.stringify({ content }),
        signal,
    });
    if (!res.ok) {
        let detail = null;
        try { detail = (await res.json()).detail; } catch (e) { /* not JSON */ }
        throw new Error(typeof detail === "string" ? detail : `Request failed (HTTP ${res.status})`);
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        let cut;
        while ((cut = buf.indexOf("\n\n")) >= 0) {
            const chunk = buf.slice(0, cut);
            buf = buf.slice(cut + 2);
            for (const line of chunk.split("\n")) {
                if (line.startsWith("data: ")) onEvent(JSON.parse(line.slice(6)));
            }
        }
    }
}

// "find · regez.visits · 12 rows · company acme"
export function stepLabel(s) {
    const where = [s.database, s.collection].filter(Boolean).join(".");
    const rows = s.rows == null ? null : `${s.rows} ${s.rows === 1 ? "row" : "rows"}`;
    return [s.tool, where, rows, s.lock].filter(Boolean).join(" · ");
}

export function prettySent(sent) {
    if (!sent) return "";
    try { return JSON.stringify(JSON.parse(sent), null, 2); } catch (e) { return String(sent); }
}

export const STEP_TONE = {
    ok: "text-emerald-300 border-emerald-400/30 bg-emerald-400/5",
    refused: "text-amber-300 border-amber-400/30 bg-amber-400/5",
    withheld: "text-red-300 border-red-400/40 bg-red-500/10",
    error: "text-red-300 border-red-400/30 bg-red-400/5",
    running: "text-white/60 border-white/15 bg-white/5",
};

// "3 min ago" for ISO timestamps (null → "never").
export function ago(iso) {
    if (!iso) return "never";
    const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
    if (s < 60) return `${s}s ago`;
    if (s < 3600) return `${Math.round(s / 60)} min ago`;
    if (s < 86400) return `${Math.round(s / 3600)} h ago`;
    return new Date(iso).toLocaleDateString();
}

export const DELIVERY_TEXT = {
    none: "Not in use",
    in_use: "In use on this hub",
    waiting: "Waiting for the server to pick it up (≤ 30 s after its next sync)",
    received: "Received by the server",
};
